import { Card, CardFooter, Col, Form } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { EditProfileTitle, UpdateProfile } from "../../../../../Constants/Constants";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { EditProfileFormBody } from "./EditProfileFormBody";

const EditProfileForm = () => {
  return (
    <Col xl="8">
      <Form onSubmit={(event) => event.preventDefault()}>
        <Card>
          <CommonCardHeader title={EditProfileTitle} />
          <EditProfileFormBody />
          <CardFooter className="text-end">
            <Btn color="primary">{UpdateProfile}</Btn>
          </CardFooter>
        </Card>
      </Form>
    </Col>
  );
};

export default EditProfileForm;
